import { Link } from 'react-router-dom'
import { Home } from 'lucide-react'

export default function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center h-screen text-center px-6">
      <p className="font-mono text-slate-600 text-sm mb-2">404</p>
      <h1 className="font-display text-2xl font-bold text-slate-300 mb-2">Page not found</h1>
      <p className="text-slate-500 text-sm mb-6">This page doesn't exist in Chatrone.</p>
      <Link to="/" className="btn-primary"><Home size={14} /> Go to Dashboard</Link>
    </div>
  )
}
